<template>
  <div style="display: flex; flex-direction: row; justify-content: space-between; height: 100vh; width: 100%; background: linear-gradient(rgb(255, 255, 255) 0%, rgb(232, 240, 254, 0.5) 100%)">
    <!-- 右侧子界面 -->
    <div style="height: 100%; width: 100%; display: flex; flex-direction: column; justify-content: start; box-sizing: border-box">
      <!-- 面包屑导航 -->
      <div class="breadcrumb-container">
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>
            <a @click="goBackToTopicAssistant" class="breadcrumb-link">论文选题协助</a>
          </el-breadcrumb-item> -->
          <el-breadcrumb-item>
            <a @click="goBackToTopicResult" class="breadcrumb-link">选题结果</a>
          </el-breadcrumb-item>
          <el-breadcrumb-item>文章详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <!-- 内容区域 -->
      <div v-if="currentArticle" style="display: flex; flex-direction: row; justify-content: center; margin: auto; width: 100%; flex: 1; overflow-y: auto">
        <iframe :src="currentArticle.url" style="width: 100%; height: 100%; border: none"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus/EventBus.js";

export default {
  name: "TopicAssistantResultIfram",
  data() {
    return {
      currentArticle: null,
    };
  },
  mounted() {
    // 从本地存储获取文章数据
    const savedArticle = sessionStorage.getItem("current_article");
    if (savedArticle) {
      this.currentArticle = JSON.parse(savedArticle);
    }
  },
  methods: {
    // 返回到论文选题协助页面
    goBackToTopicAssistant() {
      // // 从本地存储获取选题协助参数
      // const savedParams = localStorage.getItem("topic_assistant_params");
      // if (savedParams) {
      //   const { tool_idx, tool_list } = JSON.parse(savedParams);
      //   // 使用事件总线触发选题协助页面显示
      //   EventBus.$emit("showTopicAssistant", tool_idx, tool_list);
      // }
      // 清除当前文章的本地存储记录
      sessionStorage.removeItem("current_article");
      this.$router.push({ name: "home" });
    },
    // 返回到选题结果页面
    goBackToTopicResult() {
      // 清除当前文章的本地存储记录
      sessionStorage.removeItem("current_article");
      this.$router.push({ name: "topic_assistant_result" });
    },
  },
};
</script>

<style scoped>
/* 面包屑导航样式 */
.breadcrumb-container {
  padding: 15px 20px;
  background: #fff;
  border-bottom: 1px solid #e4e7ed;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.breadcrumb-link {
  color: #409eff;
  cursor: pointer;
  text-decoration: none;
}

.breadcrumb-link:hover {
  color: #66b1ff;
}
</style>
